export const DATATABLE_SERIAL_COLUMNS = [
  { key: 'serial', label: 'S.NO' },
  { key: 'id', label: 'ID' },
];

export const DATATABLE_COLUMNS = [
  { key: 'createdAt', label: 'CREATED AT', thStyle: { minWidth: '160px' } },
  { key: 'updatedAt', label: 'UPDATED AT', thStyle: { minWidth: '160px' } },
  {
    key: 'actions',
    label: 'ACTIONS',
    thStyle: { width: '100px' },
    stickyColumn: true,
  },
];

export const DELIVERY_CHALLAN_TYPES = {
  DELIVERY_CHALLAN: 'dc',
  SERVICE_DELIVERY: 'sd',
  DIRECT_SERVICE_DELIVERY: 'dd',
  VIRTUAL_STOCK_DELIVERY: 'vd',
};

export const GOOD_RECEIVING_NOTE_TYPES = {
  GOOD_RECEIVING_NOTE: 'grn',
  SERVICE_RECEIVING: 'sr',
  DIRECT_SERVICE_RECEIVING: 'dr',
  VIRTUAL_STOCK_RECEIVING: 'vr',
};

export const SALES_ORDER_STATUS = {
  NEED_APPROVAL: 'Need Approval', // Danger
  NEED_ACCOUNTS_APPROVAL: 'Need Accounts Approval', // Warning
  DRAFT: 'Draft', // Secondary
  SENT: 'Sent', // Primary
  PARTIAL: 'Partial', // Info
  COMPLETED: 'Completed', // Success
};

export const PURCHASE_ORDER_STATUS = {
  NEED_APPROVAL: 'Need Approval', // Danger
  NEED_ACCOUNTS_APPROVAL: 'Need Accounts Approval', // Warning
  DRAFT: 'Draft', // Secondary
  SENT: 'Sent', // Primary
  PARTIAL: 'Partial', // Info
  COMPLETED: 'Completed', // Success
};

export const PHYSICAL_STOCK_TAKE_STATUS = {
  NEED_APPROVAL: 'Need Approval', // Danger
  NEED_ACCOUNTS_APPROVAL: 'Need Accounts Approval', // Warning
  DRAFT: 'Draft', // Secondary
  SENT: 'Sent', // Primary
  PARTIAL: 'Partial', // Info
  COMPLETED: 'Completed', // Success
};

export const RESOURCES = {
  EMPLOYEES_DESIGNATIONS: {
    name: 'Designations',
    routeName: 'employee-designation',
    label: 'Employee Designation',
  },
  PHYSICAL_STOCK_TAKE: {
    name: 'PhysicalStockTake',
    routeName: 'physical-stock-take-list',
    label: 'Physical Stock Take',
    itemsKey: 'items',
    labelKey: 'referenceNo',
  },
  BUSINESS: {
    name: 'Business',
    routeName: 'business',
    label: 'Business',
  },
  CARTON: {
    name: 'Carton',
    routeName: '',
    label: 'Carton',
  },
  CURRENCIES: {
    name: 'Currencies',
    routeName: 'setup-currency',
    label: 'Currencies',
    itemsKey: 'items',
    labelKey: 'name',
  },
  CITIES: {
    name: 'Cities',
    routeName: 'setup-cities',
    label: 'Cities',
    itemsKey: 'cities',
    labelKey: 'name',
  },
  COUNTRIES: {
    name: 'Countries',
    routeName: 'setup-countries',
    label: 'Countries',
    itemsKey: 'countries',
    labelKey: 'name',
  },
  PROVINCES: {
    name: 'Provinces',
    routeName: 'setup-provinces',
    label: 'Provinces',
    // itemsKey: 'provinces',
    // labelKey: 'name',
  },
  AREAS: {
    name: 'Areas',
    routeName: 'setup-areas',
    label: 'Areas',
    // itemsKey: 'areas',
    // labelKey: 'name',
  },
  COLOR: {
    name: 'Color',
    routeName: '',
    label: 'Color',
  },
  COUNTRY: {
    name: 'Country',
    routeName: '',
    label: 'Country',
  },
  CUSTOMER_GROUPS: {
    name: 'CustomerGroups',
    routeName: 'customer-groups',
    label: 'Customer Groups',
    itemsKey: 'customerGroups',
    labelKey: 'groupName',
  },
  CUSTOMERS: {
    name: 'Customers',
    routeName: 'customer-list',
    label: 'Customers',
    itemsKey: 'items',
    labelKey: 'company',
  },
  CUSTOMERS_FBR: {
    name: 'CustomersFBR',
    routeName: 'customer-list',
    label: 'FBR Customers',
    itemsKey: 'items',
    labelKey: 'name',
  },
  CUSTOMER_CONTACTS: {
    name: 'CustomerContacts',
    routeName: '',
    label: 'Customer Contacts',
  },
  CUSTOMER_PHONES: {
    name: 'CustomerPhones',
    routeName: '',
    label: 'Customer Phones',
  },
  CUSTOMER_ADDRESSES: {
    name: 'CustomerAddresses',
    routeName: '',
    label: 'Customer Addresses',
  },
  M_CUSTOMER_SAVE: {
    name: 'mCustomerSave',
    routeName: '',
    label: 'Customer Save',
  },
  M_CUSTOMER_FILTER: {
    name: 'mCustomerFilter',
    routeName: '',
    label: 'Customer Filter',
  },
  CUSTOMER_TYPES: {
    name: 'CustomerTypes',
    routeName: 'customer-types',
    label: 'Customer Types',
    itemsKey: 'customerTypes',
    labelKey: 'typeName',
  },
  EMPLOYEES: {
    name: 'Employees',
    routeName: 'employee-list',
    label: 'Employees',
    itemsKey: 'items',
    labelKey: 'fullName',
  },
  EMPLOYEE_CONTACTS: {
    name: 'EmployeeContacts',
    routeName: '',
    label: 'Employee Contacts',
  },
  EMPLOYEE_ADDRESSES: {
    name: 'EmployeeAddresses',
    routeName: '',
    label: 'Employee Addresses',
  },
  EMPLOYEE_PHONES: {
    name: 'EmployeePhones',
    routeName: '',
    label: 'Employee Phones',
  },
  EMPLOYEE_CREDENTIALS: {
    name: 'EmployeeCredentials',
    routeName: '',
    label: 'Employee Credentials',
  },
  EMPLOYEES_TIMINGS: {
    name: 'EmployeesTimings',
    routeName: '',
    label: 'Employees Timings',
  },
  M_EMPLOYEE_SAVE: {
    name: 'mEmployeeSave',
    routeName: '',
    label: 'Employee Save',
  },
  M_EMPLOYEE_FILTER: {
    name: 'mEmployeeFilter',
    routeName: '',
    label: 'Employee Filter',
  },
  EMPLOYEES_DEPARTMENTS: {
    name: 'EmployeesDepartments',
    routeName: 'employee-departments',
    label: 'Employee Departments',
  },
  HS_CODE: {
    name: 'HSCode',
    routeName: '',
    label: 'HS Code',
  },
  M_EMPLOYEES_DEPARTMENT_SAVE: {
    name: 'mEmployeesDepartmentSave',
    routeName: '',
    label: 'Employee Department Save',
  },
  FLAGS: {
    name: 'Flags',
    routeName: '',
    label: 'Flags',
    itemsKey: 'flags',
    labelKey: 'name',
  },
  FORM_GROUPS: {
    name: 'FormGroups',
    routeName: '',
    label: 'Form Groups',
  },
  FORMS: {
    name: 'Forms',
    routeName: '',
    label: 'Forms',
    itemsKey: 'results',
    // labelKey: 'name',
  },
  INTERNAL_DELIVERY: {
    name: 'InternalDelivery',
    routeName: 'internal-delivery-list',
    label: 'Internal Delivery',
  },
  INTERNAL_DELIVERY_DETAILS: {
    name: 'InternalDeliveryDetails',
    routeName: '',
    label: 'Internal Delivery Details',
  },
  M_INTERNAL_DELIVERY_SAVE: {
    name: 'mInternalDeliverySave',
    routeName: '',
    label: 'Internal Delivery Save',
  },
  INVENTORY_BRAND: {
    name: 'InventoryBrands',
    routeName: '',
    label: 'Inventory Brands',
    itemsKey: 'brands',
    labelKey: 'name',
  },
  INVENTORY_CATEGORY: {
    name: 'InventoryCategories',
    routeName: '',
    label: 'Inventory Categories',
    itemsKey: 'categories',
    labelKey: 'name',
  },
  INVENTORY_COMMODITY: {
    name: 'InventoryCommodities',
    routeName: '',
    label: 'Inventory Commodities',
    itemsKey: 'commodities',
    labelKey: 'name',
  },
  INVENTORY_COMMODITY_GROUP: {
    name: 'InventoryCommodityGroups',
    routeName: '',
    label: 'Inventory Commodity Groups',
    itemsKey: 'items',
    labelKey: 'name',
  },
  CUSTOMER_GROUP_PRICING: {
    name: 'CustomerGroupPricing',
    routeName: '',
    label: 'Customer Group Pricing',
  },
  SALES_ORDER_TYPE: {
    name: 'SalesOrderTypes',
    routeName: 'sales-order-type',
    label: 'Sales Order Type',
    itemsKey: 'salesOrderTypes',
    labelKey: 'name',
  },
  STATION_TYPE: {
    name: 'StationTypes',
    routeName: 'station-type',
    label: 'Station Type',
    itemsKey: 'items',
    labelKey: 'name',
  },
  INVENTORY_ITEM_PRICING: {
    name: 'InventoryItemPricing',
    routeName: 'price-list',
    label: 'Price List',
    itemsKey: 'items',
    labelKey: 'name',
  },
  PRICE_LIST: {
    name: 'PricingData',
    routeName: 'price-list',
    label: 'Price List',
    itemsKey: 'items',
    labelKey: 'name',
  },
  PROJECTS: {
    name: 'Projects',
    routeName: 'projects-list',
    label: 'Projects',
    itemsKey: 'items',
    labelKey: 'name',
  },
  M_INVENTORY_ITEM_PRICING_SAVE: {
    name: 'mInventoryItemPricingSave',
    routeName: '',
    label: 'Inventory Item Pricing Save',
  },
  INVENTORY_ITEMS: {
    name: 'InventoryItems',
    routeName: 'item-list',
    label: 'Inventory Items',
  },
  ITEMS_FBR: {
    name: 'ItemsFBR',
    routeName: 'item-list',
    label: 'FBR Items',
    itemsKey: 'items',
    labelKey: 'itemName',
  },
  INVENTORY_OPENING_STOCK: {
    name: 'InventoryOpeningStock',
    routeName: 'opening-stock',
    label: 'Inventory Opening Stocks',
  },
  INVENTORY_SUB_GROUP: {
    name: 'InventorySubGroups',
    routeName: '',
    label: 'Inventory Sub Groups',
  },
  INVENTORY_UNIT: {
    name: 'InventoryUnits',
    routeName: '',
    label: 'Inventory Units',
  },
  RETURN_REASON: {
    name: 'ReturnReason',
    routeName: '',
    label: 'Return Reasons',
    itemsKey: 'returnReasons',
    labelKey: 'reason',
  },
  USERS: {
    name: 'Users',
    routeName: 'manage-users',
    label: 'Users',
    itemsKey: 'users',
    labelKey: 'name',
  },
  LOGS_DATA: {
    name: 'LogsData',
    routeName: '',
    label: 'Logs Data',
  },
  MANUFACTURERS: {
    name: 'Manufacturers',
    routeName: '',
    label: 'Manufacturers',
  },
  M_MANUFACTURER_SAVE: {
    name: 'mManufacturerSave',
    routeName: '',
    label: 'Manufacturer Save',
  },
  M_MANUFACTURER_FILTER: {
    name: 'mManufacturerFilter',
    routeName: '',
    label: 'Manufacturer Filter',
  },
  MODEL: {
    name: 'Models',
    routeName: '',
    label: 'Models',
  },
  ORIGIN: {
    name: 'Origins',
    routeName: '',
    label: 'Origins',
    itemsKey: 'origins',
    labelKey: 'name',
  },
  ROLES: {
    name: 'Roles',
    routeName: '',
    label: 'Roles',
    itemsKey: 'results',
    labelKey: 'name',
  },
  SIZE: {
    name: 'Sizes',
    routeName: '',
    label: 'Sizes',
  },
  STYLE: {
    name: 'Styles',
    routeName: '',
    label: 'Styles',
  },
  JWT_MODEL: {
    name: 'JWTModel',
    routeName: '',
    label: 'JWT Model',
  },
  USER_BUSINESS: {
    name: 'UserBusiness',
    routeName: '',
    label: 'User Business',
  },
  M_USER_SAVE: {
    name: 'mUserSave',
    routeName: '',
    label: 'User Save',
  },
  M_USER_LOGIN: {
    name: 'mUserLogin',
    routeName: '',
    label: 'User Login',
  },
  VENDOR_CATEGORIES: {
    name: 'VendorCategories',
    routeName: 'vendor-groups',
    label: 'Vendor Category',
    itemsKey: 'vendorCategories',
    labelKey: 'categoryName',
  },
  VENDORS: {
    name: 'Vendors',
    routeName: 'vendor-list',
    label: 'Vendors',
    itemsKey: 'items',
    labelKey: 'company',
  },
  VENDOR_CONTACTS: {
    name: 'VendorContacts',
    routeName: '',
    label: 'Vendor Contacts',
  },
  VENDOR_PHONES: {
    name: 'VendorPhones',
    routeName: '',
    label: 'Vendor Phones',
  },
  VENDOR_ADDRESSES: {
    name: 'VendorAddresses',
    routeName: '',
    label: 'Vendor Addresses',
  },
  M_VENDOR_SAVE: {
    name: 'mVendorSave',
    routeName: '',
    label: 'Vendor Save',
  },
  M_VENDOR_FILTER: {
    name: 'mVendorFilter',
    routeName: '',
    label: 'Vendor Filter',
  },
  VENDOR_TYPES: {
    name: 'VendorTypes',
    routeName: 'vendor-types',
    label: 'Vendor Types',
    itemsKey: 'vendorTypes',
    labelKey: 'typeName',
  },
  VENUES: {
    name: 'Venues',
    routeName: '',
    label: 'Venues',
    itemsKey: 'venues',
    labelKey: 'name',
  },
  WAREHOUSES: {
    name: 'Warehouses',
    routeName: 'warehouses-list',
    label: 'Warehouses',
    itemsKey: 'warehouses',
    labelKey: 'warehouseName',
  },
  WAREHOUSE_TYPES: {
    name: 'WarehouseTypes',
    routeName: 'warehouse-types',
    label: 'Warehouse Types',
    itemsKey: 'warehouseTypes',
    labelKey: 'typeName',
  },
  // Adding new routes from the provided JSON
  IBICO_DASHBOARD: {
    name: 'IbicoDashboard',
    routeName: 'ibico-dashboard',
    label: 'Ibico Dashboard',
  },
  EMPLOYEE_DESIGNATION: {
    name: 'EmployeeDesignation',
    routeName: 'employee-designation',
    label: 'Employee Designation',
  },
  SALES_INVOICE: {
    name: 'SalesInvoices',
    routeName: 'sales-invoice',
    label: 'Sales Invoice',
    itemsKey: 'items',
    labelKey: 'invoiceNumber',
  },
  IBICO_INVOICE: {
    name: 'IbicoInvoices',
    routeName: 'ibico-invoice',
    label: 'Ibico Invoice',
    itemsKey: 'items',
    labelKey: 'invoiceNumber',
  },
  SALES_RETURN: {
    name: 'SalesReturns',
    routeName: 'sales-return',
    label: 'Sales Return',
  },
  SALES_ORDER: {
    name: 'SalesOrders',
    routeName: 'sales-order',
    label: 'Sales Order',
    itemsKey: 'items',
    labelKey: 'saleOrderNo',
  },
  REPORTS: {
    name: 'Reports',
    routeName: 'reports',
    label: 'Reports',
  },
  PURCHASE_ORDERS: {
    name: 'PurchaseOrders',
    routeName: 'purchase-order',
    label: 'Purchase Order',
    itemsKey: 'items',
    labelKey: 'purchaseOrderNo',
  },
  PURCHASE_INVOICE: {
    name: 'PurchaseInvoices',
    routeName: 'purchase-invoice',
    label: 'Purchase Invoice',
    itemsKey: 'items',
    labelKey: 'invoiceNumber',
  },
  SETUP_CURRENCY: {
    name: 'SetupCurrency',
    routeName: 'setup-currency',
    label: 'Setup Currency',
    itemsKey: 'items',
    labelKey: 'name',
  },
  DELIVERY_CHALLAN: {
    name: 'DeliveryChallan',
    routeName: 'delivery-challan',
    label: 'Delivery Challan',
  },
  SERVICES_DELIVERY: {
    name: 'DeliveryChallan',
    routeName: 'services-delivery',
    label: 'Services Delivery',
  },
  DIRECT_SERVICE_DELIVERY: {
    name: 'DeliveryChallan',
    routeName: 'direct-service-delivery',
    label: 'Direct Service Delivery',
  },
  VIRTUAL_STOCK_DELIVERY: {
    name: 'DeliveryChallan',
    routeName: 'virtual-stock-delivery',
    label: 'Virtual Stock Delivery',
  },
  INVENTORY_HISTORY: {
    name: 'InventoryHistory',
    routeName: 'inventory-history',
    label: 'Inventory History',
  },
  INVENTORY_SETTINGS: {
    name: 'InventorySettings',
    routeName: 'inventory-settings',
    label: 'Inventory Settings',
  },
  STOCK_INPUT: {
    name: 'StockInput',
    routeName: 'stock-input-list',
    label: 'Stock Input',
  },
  LOSS_ADJUSTMENT: {
    name: 'LossAndAdjustment',
    routeName: 'loss-adjustment-list',
    label: 'Loss Adjustment',
  },
  SALES_ORDERS: {
    name: 'SalesOrders',
    routeName: 'sales-order',
    label: 'Sales Orders',
    itemsKey: 'items',
    labelKey: 'saleOrderNo',
  },
  GENERAL_ISSUANCE: {
    name: 'GeneralIssuance',
    routeName: 'general-issuance-list',
    label: 'General Issuance',
  },
  TEMPORARY_ISSUANCE: {
    name: 'TemporaryIssuance',
    routeName: 'temporary-issuance-list',
    label: 'Temporary Issuance',
  },
  PHYSICAL_STOCK_TAKE: {
    name: 'PhysicalStockTake',
    routeName: 'physical-stock-take-list',
    label: 'Physical Stock Take',
    itemsKey: 'items',
    labelKey: 'referenceNo',
  },
  GOOD_RECEIVING_NOTE: {
    name: 'GoodsReceivingNotes',
    routeName: 'good-receiving-note',
    label: 'Good Receiving Note',
  },
  CHARTS_OF_ACCOUNTS: {
    name: 'ChartofAccounts',
    routeName: 'charts-of-accounts',
    label: 'Charts of Accounts',
    itemsKey: 'items',
    labelKey: 'accountName',
  },
  BANK: {
    name: 'Banks',
    routeName: 'bank',
    label: 'Bank',
  },
  BANK_PROFILE: {
    name: 'BankProfiles',
    routeName: 'bank-profile',
    label: 'Bank Profile',
  },
  ACCOUNT_DETAIL_TYPES: {
    name: 'AccountDetailTypes',
    routeName: 'account-detail-types',
    label: 'Account Detail Types',
  },
  COST_CENTER: {
    name: 'CostCenter',
    routeName: 'cost-center',
    label: 'Cost Center',
  },
  MAPPING_SETUP: {
    name: 'MappingSetup',
    routeName: 'mapping-setup',
    label: 'Mapping Setup',
  },
  TRANSFERS: {
    name: 'TransferEntries',
    routeName: 'transfer',
    label: 'Transfers',
  },
  RECEIPT_CREDIT_VOUCHER: {
    name: 'CreditVouchers',
    routeName: 'receipt-credit-voucher',
    label: 'Receipt/Credit Voucher',
  },
  PAYMENTS_DEBIT_VOUCHER: {
    name: 'DebitVouchers',
    routeName: 'payments-debit-voucher',
    label: 'Payments/Debit Voucher',
  },
  PURCHASE_RETURN: {
    name: 'PurchaseReturns',
    routeName: 'purchase-return',
    label: 'Purchase Return',
  },
  EXPENSE_ITEMS: {
    name: 'ExpenseItems',
    routeName: 'expense-items',
    label: 'Expense Items',
    itemsKey: 'items',
    labelKey: 'accountName',
  },
  FUNDS: {
    name: 'Funds',
    routeName: 'funds',
    label: 'Funds',
    itemsKey: 'items',
    labelKey: 'fundReference',
  },
  JOURNAL_ENTRIES: {
    name: 'JournalEntry',
    routeName: 'journal-list',
    label: 'Journal Entries',
    itemsKey: 'items',
    labelKey: 'description',
  },
  METER_READINGS: {
    name: 'MeterReadings',
    routeName: 'meter-readings-list',
    label: 'Meter Readings',
    itemsKey: 'items',
    labelKey: 'id',
  },
  MONTHLY_PAYMENT_SCHEDULES: {
    name: 'MonthlyPaymentSchedule',
    routeName: 'monthly-payment-schedules-list',
    label: 'Monthly Payment Schedules',
    itemsKey: 'items',
    labelKey: 'id',
  },
  REJECTION_JOURNEY: {
    name: 'RejectionJourney',
    routeName: 'rejection-journey',
    label: 'Rejection Journey',
    itemsKey: 'items',
    labelKey: 'id',
  },
  DUE_RECEIVABLE_SCHEDULES: {
    name: 'DueReceivableSchedule',
    routeName: 'due-receivable-schedule-list',
    label: 'Due Receivable Schedule',
    itemsKey: 'items',
    labelKey: 'id',
  },
  FUEL_VOUCHERS: {
    name: 'FuelVoucher',
    routeName: 'fuel-vouchers-list',
    label: 'Fuel Vouchers',
    itemsKey: 'items',
    labelKey: 'id',
  },
  BUDGETS: {
    name: 'Budget',
    routeName: 'budget-list',
    label: 'Budget Entries',
    itemsKey: 'items',
    labelKey: 'title',
  },
  ACCOUNT_ROUTES: {
    name: 'Routes',
    routeName: 'accounts-routes-list',
    label: 'Account Routes',
    itemsKey: 'items',
    labelKey: 'name',
  },
  EXPENSE_ENTRIES: {
    name: 'Expense',
    routeName: 'expense-list',
    label: 'Expense Entries',
    itemsKey: 'items',
    labelKey: 'expenseNumber',
  },
  CHEQUES: {
    name: 'Cheques',
    routeName: 'cheque-list',
    label: 'Cheques',
  },
  POSTDATED_CHEQUES: {
    name: 'PostDatedCheques',
    routeName: 'post-dated-cheques-list',
    label: 'Post Dated Cheques',
  },
  REQUISITIONS: {
    name: 'Requisition',
    routeName: 'requisition',
    label: 'Requisition',
    itemsKey: 'items',
    labelKey: 'requisition',
  },
  REQUISITION_QUOTATIONS: {
    name: 'Quotation',
    routeName: 'requisition-quotation',
    label: 'Requisition Quotation',
    itemsKey: 'items',
    labelKey: 'quotationNumber',
  },
  PHYSICAL_CASH_VERIFICATIONS: {
    name: 'PhysicalCashVerification',
    routeName: 'physical-cash-verification-list',
    label: 'Physical Cash Verification',
    itemsKey: 'items',
    labelKey: 'id',
  },
  // unit of measure
  UNIT_OF_MEASURE: {
    name: 'UnitOfMeasure',
    routeName: 'unit-of-measure-list',
    label: 'Unit of Measure',
    itemsKey: 'items',
    labelKey: 'name',
  },
  // Item Groups
  ITEM_GROUP: {
    name: 'ItemGroup',
    routeName: 'item-group-list',
    label: 'Item Group',
    itemsKey: 'items',
    labelKey: 'name',
  },
  // FBR Item Groups
  ITEM_GROUPS: {
    name: 'ItemGroups',
    routeName: 'item-group-list',
    label: 'FBR Item Groups',
    itemsKey: 'items',
    labelKey: 'name',
  },
  SALES_TYPES: {
    name: 'SalesTypes',
    routeName: 'sales-type-list',
    label: 'FBR Sales Types',
    itemsKey: 'items',
    labelKey: 'name',
  },
  // HS Codes
  HS_CODE: {
    name: 'HSCode',
    routeName: 'hs-code-list',
    label: 'HS Code',
    itemsKey: 'items',
    labelKey: 'name',
  },
  BUSINESS: {
    name: 'Business',
    routeName: 'business-list',
    label: 'Business',
    itemsKey: 'items',
    labelKey: 'name',
  },
};
